export class ActionItemDTO{

    public id!:number;
    public customerId!:number
    public moovInstanceId!:number;
    public userId?:number;
    public actionType!:number;
    public actionReferenceId?:string;
    public objectReferences?:string;
    public actionTaken:boolean = false;
    public actionTakenByUserId?:number;
    public actionTakenAt?:string;
    public typeOfActionTaken?:string;
    public remarkForActionTaken?:string;
    public added?:string;
    public edited?:string;
    
}